export default "__VITE_ASSET__BVWPYMkg__"